export const padNumber = (number: number) => String(number).padStart(2, '0');
